import React from "react";
import { Card } from "primereact/card";
import { Link, useLocation, useParams } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";

const EmployeeSideBar = ({ employeeDetails, isDataAvailable }) => {
  const location = useLocation();
  const { id } = useParams();
  const activeTab = location.pathname.split("/")[3] || "info";

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0] ? nameArray[0].charAt(0) : "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  return (
    <>
      <Card className="employee-details-card">
        <div className="flex flex-column employee-profile">
          <div className="avatar-container mb-3">
            <h3>
              {getInitials(
                `${employeeDetails?.name} ${employeeDetails?.last_name}`,
              )}
            </h3>
          </div>
          <div className="employee_name">
            {isDataAvailable &&
            employeeDetails?.name &&
            employeeDetails?.last_name ? (
              <p className="employee-details-heading">
                {employeeDetails?.name}{" "}
                {employeeDetails?.other_name
                  ? employeeDetails?.other_name
                  : null}{" "}
                {employeeDetails?.last_name}
              </p>
            ) : (
              <Skeleton width="150px" height="20px" className="mr-1" />
            )}
            {isDataAvailable && (
              <p className="m-0">{employeeDetails?.job_title}</p>
            )}
            {isDataAvailable ? (
              <p className="m-0">
                <ReactCountryFlag
                  countryCode={employeeDetails?.country}
                  svg
                  className=""
                />{" "}
                {getName(employeeDetails?.country || "")}
              </p>
            ) : (
              <Skeleton width="150px" height="20px" className="mr-1" />
            )}
          </div>

          <div className="other_datail">
            <span className="flex align-items-center  gap-2 other__detail mb-2">
              {isDataAvailable ? (
                <>
                  <i className="pi pi-envelope" />
                  {employeeDetails?.personal_email}
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </span>
            <span className="flex align-items-center  gap-2 other__detail">
              {isDataAvailable ? (
                <>
                  <i className="pi pi-phone" /> {employeeDetails?.phone_number}
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </span>
          </div>
        </div>
        <div className="flex flex-column gap-1">
          <Link
            to={`/employee/${id}/info`}
            className={`sidebar-align ${activeTab === "info" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Personal Information</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          <Link
            to={`/employee/${id}/address`}
            className={`sidebar-align ${activeTab === "address" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Location & Address</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          <Link
            to={`/employee/${id}/employment-information`}
            className={`sidebar-align ${activeTab === "employment-information" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Employment Information</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          <Link
            to={`/employee/${id}/bank-information`}
            className={`sidebar-align ${activeTab === "bank-information" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Bank Information</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          <Link
            to={`/employee/${id}/attachments`}
            className={`sidebar-align ${activeTab === "attachments" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Attachments</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
        </div>
      </Card>
    </>
  );
};

export default EmployeeSideBar;
